import Carousel from "react-material-ui-carousel";
import { ImageCaraouselSlideUpText } from "./imageCaraousel-SlideUpText";
import {
  ImageCarouselContentContainer,
  ImageCarouselContentImage,
} from "./styles";
import { CarouselSlide } from "../../../sanity/types";
import { urlFor } from "../../../sanity/image";

interface Props {
  slides: CarouselSlide[];
}

export function ImageCarousel({ slides }: Props) {
  if (!slides.length) {
    return null;
  }

  return (
    <Carousel
      animation="fade"
      swipe={true}
      indicators={false}
      // autoPlay={false} // Uncomment/Comment for Live/Test
      height="25vw"
      stopAutoPlayOnHover={true}
      interval={5000}
      strictIndexing={true}
      sx={{ minHeight: "125px" }}
    >
      {slides.map((slide, i) => {
        const imageUrl = slide.image
          ? urlFor(slide.image).width(2000).url()
          : slide.imageUrl
          ? process.env.PUBLIC_URL + slide.imageUrl
          : "";
        if (!imageUrl) {
          return null;
        }
        const altText =
          slide.altText ||
          slide.image?.alt ||
          slide.primaryText ||
          "Carousel image";
        return (
          <ImageCarouselContentContainer key={slide._key || i}>
            <ImageCarouselContentImage
              src={imageUrl}
              alt={altText}
              loading={i === 0 ? "eager" : "lazy"}
            />
            <ImageCaraouselSlideUpText
              primaryText={slide.primaryText || ""}
              secondaryText={slide.secondaryText || ""}
            />
          </ImageCarouselContentContainer>
        );
      })}
    </Carousel>
  );
}
